import React from 'react'

import { useTranslation } from 'language/translator'

import Icon from 'components_new/atoms/Icon'
import ListItemButton from 'components_new/atoms/List/ListItemButton'
import ListItemIcon from 'components_new/atoms/List/ListItemIcon'
import ListItemText from 'components_new/atoms/List/ListItemText'
import Switch from 'components_new/atoms/Switch'

import FormSection from 'components_new/molecules/FormSection'

interface AccessProps {
  onSubmit: (value: boolean) => void
  value: boolean
}

const Access = (props: AccessProps) => {
  const { onSubmit, value } = props

  const { t } = useTranslation()

  return (
    <FormSection
      helperText={t('groups', 'access_helper_text')}
      importance="optional"
      size="small"
      title={t('global', 'access')}
    >
      <ListItemButton
        onClick={() => onSubmit(!value)}
        sx={{ bgcolor: 'background.default' }}
      >
        <ListItemIcon>
          <Icon name={'Private'} />
        </ListItemIcon>
        <ListItemText
          primary={t('groups', 'private_group_title')}
          secondary={t('groups', 'private_group_helper_text')}
          secondaryTypographyProps={{ color: 'text.secondary' }}
        />
        <Switch
          checked={value}
          onChange={() => onSubmit(!value)}
          value={value}
        />
      </ListItemButton>
    </FormSection>
  )
}

export default Access
